import { BANKS, DEAL_STEPS } from '../../../constants';
import { CAR_ORIGIN_TYPES } from '../../../constants/carOrigin';
import { tenant, tripartiteContractEnabled } from '../../../brand/tenant';

/**
 * Первый шаг сделки после выбора банка. Вынесен из onBankSelect, потому что для
 * авто по договору поручения между выбором банка и этим шагом вклинивается
 * формирование трёхстороннего договора — и вернуться в поток нужно в ту же точку.
 */
const bankFirstStep = (bankId, appeal) => {
  switch (bankId) {
    case BANKS.HALYK:
      return DEAL_STEPS.HALYK.WAITING_FOR_PAYMENT;
    case BANKS.FREEDOM:
      // Комиссионное авто идёт по укороченному маршруту и начинается с ДКП;
      // экран ожидания клиента на сайте банка относится только к новым авто.
      return (appeal?.stockType || '').toUpperCase().startsWith('THRIFT')
        ? DEAL_STEPS.FREEDOM.SIGN_CONTRACT
        : DEAL_STEPS.FREEDOM.WAITING_FOR_CLIENT_ACTIONS_ON_FREEDOM_SITE;
    case BANKS.FORTE:
      return DEAL_STEPS.FORTE.WAITING_FOR_PAYMENT;
    case BANKS.BEREKE:
      return DEAL_STEPS.BEREKE.WAITING_FOR_CLIENT_ACTIONS;
    case BANKS.BCK:
      return DEAL_STEPS.BCK.WAITING_FOR_PAYMENT;
    case BANKS.ALTYN:
      return DEAL_STEPS.ALTYN.WAITING_FOR_PAYMENT;
    case BANKS.EURAZ:
      return DEAL_STEPS.EURAZ.SIGN_CONTRACT;
    default:
      return DEAL_STEPS.NOTARIAL_DOCUMENTS;
  }
};

/**
 * Авто в сделке поставлено по договору поручения — нужен трёхсторонний договор.
 * У брокера, где договор выключен (JetQ), сделка идёт обычным путём банка.
 */
export const isConsignmentDeal = (cars, current = tenant) =>
  tripartiteContractEnabled(current) &&
  (cars || []).some((item) => item?.originCarId === CAR_ORIGIN_TYPES.CONSIGNMENT);

/**
 * Куда уходит сделка после выбора банка. Единственная точка правды: и
 * onBankSelect, и стрелка «→» на шаге банков (DealCredits) должны одинаково
 * заворачивать поручение на трёхсторонний договор, иначе шаг обходится.
 */
export const stepAfterBankSelect = (bankId, appeal, cars) =>
  isConsignmentDeal(cars) ? DEAL_STEPS.TRIPARTITE_CONTRACT : bankFirstStep(bankId, appeal);

export default bankFirstStep;
